import { render, staticRenderFns } from "./RecordedTableItems.vue?vue&type=template&id=51941cb6&scoped=true&"
import script from "./RecordedTableItems.vue?vue&type=script&lang=ts&"
export * from "./RecordedTableItems.vue?vue&type=script&lang=ts&"
import style0 from "./RecordedTableItems.vue?vue&type=style&index=0&id=51941cb6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51941cb6",
  null
  
)

export default component.exports